/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class Featureflags<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
 * No description
 *
 * @tags FeatureFlags
 * @name Get
 * @summary Anonymous read of one feature flag. The request host is passed so host-targeted flags can be
            evaluated; any evaluation error is reported as off.
 * @request GET:/api/v1/featureflags/{featureFlag}
 * @secure
 * @response `200` `void` OK
 */
  get = (featureFlag: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/api/v1/featureflags/${featureFlag}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
